import formReducer, {
  emptyMultiSelectField,
  emptySelectField,
  formHelperMethodFactory,
} from 'reducers/FormReducer/FormReducer'
import {
  createFormField,
  withValidationFactory,
  type BaseValidationField,
  type FormReducerMultiSelectField,
  type FormReducerSelectField,
  type PickByType,
  type ValidationObject,
} from 'reducers/FormReducer/utils'
import type { ExtractElementType } from 'utils/utils.d'
import type { ProjectsDetailResult } from '@contracts'

export interface AddRegionToProjectFormReducerState {
  region_id: FormReducerSelectField
  retailers: FormReducerMultiSelectField
}

type PickAddRegionToProjectStateField<T> = PickByType<AddRegionToProjectFormReducerState, T>

// Define the keys of the fields that match the correct element types
export type AddRegionToProjectMultiSelectField = PickAddRegionToProjectStateField<FormReducerMultiSelectField>
export type AddRegionToProjectSelectField = PickAddRegionToProjectStateField<FormReducerSelectField>

// Get the keys of the fields that have a value and an error field
export type NewProjectValidationFields = BaseValidationField<AddRegionToProjectFormReducerState>

export const defaultAddRegionToProjectErrorObject: ValidationObject<'AddRegionToProjectFormReducerState'> = {}
const withValidation = withValidationFactory(defaultAddRegionToProjectErrorObject)

// Define the initial state of the form
export const emptyAddRegionToProjectFormReducerState: AddRegionToProjectFormReducerState = {
  region_id: withValidation(emptySelectField, 'region_id', ['requiredField'], []),
  retailers: withValidation(emptyMultiSelectField, 'retailers', ['requiredField'], []),
}

export const initialRegionFormReducerState = (
  data: ExtractElementType<ProjectsDetailResult['regions']>,
): AddRegionToProjectFormReducerState => ({
  region_id: withValidation(createFormField('select', data.region_id || ''), 'region_id', ['requiredField'], []),
  retailers: withValidation(createFormField('multiSelect', data.retailers || []), 'retailers', ['requiredField'], []),
})

const addRegionToProjectFormReducer = formReducer<'AddRegionToProjectFormReducerState'>
export const addRegionToProjectFormHelperFunctions = formHelperMethodFactory<'AddRegionToProjectFormReducerState'>()
export default addRegionToProjectFormReducer
